import Vue from 'vue';
import { InternalSite, siteAdminApis } from '@/api/site_admin.api';
import { ActionContext, Module } from 'vuex';

export interface SitesState {
  all: Array<InternalSite>;
}

export default {
  namespaced: true,
  state: () => ({ all: [] }),
  getters: {
    getSites(state: SitesState) {
      return state.all;
    },
    getSite: (state: SitesState) => (id: number) => state.all.find(s => s.id === id)
  },
  mutations: {
    setSites(state: SitesState, sites: Array<InternalSite>) {
      state.all = sites;
    },
    updateSite(state: SitesState, site: InternalSite) {
      const index = state.all.findIndex(s => s.id === site.id);
      if (index >= 0) {
        Vue.set(state.all, index, site);
      } else {
        state.all.push(site);
      }
    },
    deleteSite(state: SitesState, site: InternalSite) {
      const index = state.all.findIndex(s => s.id === site.id);
      if (index >= 0) {
        state.all.splice(index, 1);
      }
    }
  },
  actions: {
    async refresh<R>({ commit }: ActionContext<SitesState, R>) {
      const result = await siteAdminApis.listSites();
      commit('setSites', result.sites);
    },
    async save<R>({ commit }: ActionContext<SitesState, R>, site: InternalSite) {
      commit('updateSite', await siteAdminApis.updateSite(site));
    },
    async saveAddress<R>({ commit }: ActionContext<SitesState, R>, site: InternalSite) {
      commit('updateSiteAddress', await siteAdminApis.updateSiteAddress(site));
    },
    async delete<R>({ commit }: ActionContext<SitesState, R>, site: InternalSite) {
      await siteAdminApis.deleteSite(site.id);
      commit('deleteSite', site);
    }
  }
} as Module<SitesState, any>;
